export enum ImageType {
  BackImage = 'backImage',
  FrontImage = 'frontImage',
  Selfie = 'selfie'
}
